import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import {
  MatDatepickerInputEvent,
  MatDialog
} from "@angular/material";
import * as moment from "moment";
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

@Component({
  selector: "app-payout-callback",
  templateUrl: "./payout-callback.component.html",
  styleUrls: ["./payout-callback.component.css"],
})
export class PayoutCallbackComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
    cellStyle: { display: 'flex', alignItems: 'center' }
  };

  oPayouts: any = [];
  payouts: any = [];
  rowData: any[] = [];
  filter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    PayoutOrderId: "",
    provider: "ALL", // gateway code, ALL = every gateway
  };
  // Gateway codes from Offramp Payout Gateways (loadGatewayOptions)
  providerOptions: string[] = ["ALL"];
  prev_disabled = true;
  next_disabled = false;

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
    this.loadGatewayOptions();
  }

  // One entry per gateway code (a gateway with several MIDs is listed once)
  loadGatewayOptions() {
    this.offrampService.getPayoutGatewayLookup().subscribe(
      (response: any) => {
        const codes = ((response && response.data) || []).map((gateway) => gateway.code).filter((code) => !!code);
        this.providerOptions = ["ALL", ...Array.from(new Set<string>(codes))];
      },
      (error) => {
        console.error("Error loading payout gateways:", error);
      }
    );
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'flex-start';
          container.style.height = '100%';
          container.style.width = '100%';

          const viewBtn = document.createElement('button');
          viewBtn.type = 'button';
          viewBtn.className = 'btn btn-sm btn-info';
          viewBtn.title = 'View';
          viewBtn.style.display = 'flex';
          viewBtn.style.alignItems = 'center';
          viewBtn.style.justifyContent = 'center';
          viewBtn.style.padding = '4px 8px';
          viewBtn.innerHTML = '<i class="fa fa-eye"></i>';
          viewBtn.onclick = (e) => {
            e.stopPropagation();
            this.displayProperJson(element);
          };
          container.appendChild(viewBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 0.8,
        minWidth: 90,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }
      },
      { headerName: 'Provider', field: 'Provider', flex: 1 },
      { headerName: 'Payout Order Id', field: 'PayoutOrderId', flex: 1.5 },
      { headerName: 'Payment Ref Id', field: 'PaymentRefId', flex: 1.5 },
      { headerName: 'Payment Txn Id', field: 'PaymentTxnId', flex: 1.5 },
      { headerName: 'Amount', field: 'PayoutAmount', flex: 1 },
      { headerName: 'Status', field: 'PayoutStatus', flex: 1 },
      { headerName: 'WebHook Url', field: 'WebHookUrl', flex: 2 },
      {
        headerName: 'Created At',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      enableCellTextSelection: true,
      ensureDomOrder: true
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext() {
    this.filter.page++;
    this.getData();
  }

  goPrev() {
    if (this.filter.page > 1) {
      this.filter.page--;
      this.getData();
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  search() {
    this.filter.page = 1;
    this.getData();
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getPayoutCallbacks(this.filter).subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      this.next_disabled = !list || list.length < this.filter.limit;
    });
  }

  displayProperJson(jsonData) {
    let obj = {
      jsonData: jsonData,
      eventType: "payout callback"
    }
    this.dialog.open(ProperJsonDialogComponent, {
      width: 'auto',
      height: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-callback/payout-callback.component.ts